interface PlatformBadgeProps {
  platform: string;
  size?: 'sm' | 'md';
}

const PLATFORM_CONFIG: Record<string, { label: string; color: string; icon: string }> = {
  twitter: { label: 'X', color: '#000000', icon: '𝕏' },
  instagram: { label: 'Instagram', color: '#E4405F', icon: '📷' },
  tiktok: { label: 'TikTok', color: '#000000', icon: '♪' },
  facebook: { label: 'Facebook', color: '#1877F2', icon: 'f' },
  youtube: { label: 'YouTube', color: '#FF0000', icon: '▶' },
  direct: { label: 'Direct Story', color: '#2b5e49', icon: '✍' },
};

export function PlatformBadge({ platform, size = 'sm' }: PlatformBadgeProps) {
  const cfg = PLATFORM_CONFIG[platform] || { label: platform, color: '#666', icon: '?' };
  const px = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium text-white ${px}`}
      style={{ backgroundColor: cfg.color }}
    >
      <span className="leading-none">{cfg.icon}</span>
      {cfg.label}
    </span>
  );
}
